import React from 'react';
import { Tooltip, Button } from 'antd';
import cn from 'classnames';
import styles from './IconBtn.module.scss';

const IconBtn = ({ className, tooltipTitle, ...props }) => {
  return (
    <Tooltip title={tooltipTitle}>
      <Button
        ghost
        shape="circle"
        {...props}
        className={cn(styles.root, className)}
      />
    </Tooltip>
  );
};

export default IconBtn;
